var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"block-list"},_vm._l((_vm.blocksOrdered),function(block,index){return _c('div',{staticClass:"block-item"},[_c(block.type,{tag:"component",attrs:{"name":block.name,"input":block}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }